// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"a69a4c16","159":"615c025a","317":"d4be6615","453":"e686bfa8","496":"5c971d04","512":"77c89158","902":"3e851ba6","938":"b5345b4b"}[chunkId] + ".chunk.js";
};